import axios from 'axios';
import config from '../config/api';

const API_BASE_URL = config.endpoints.locations;

export const locationService = {
  // Obtener todos los países
  async getCountries() {
    try {
      const response = await axios.get(`${API_BASE_URL}/countries`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener países:', error);
      throw error;
    }
  },

  // Obtener estados/provincias de un país
  async getStates(countryIsoCode) {
    try {
      const response = await axios.get(`${API_BASE_URL}/states/${countryIsoCode}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener estados:', error);
      throw error;
    }
  },

  // Obtener ciudades de un estado
  async getCities(countryIsoCode, stateIsoCode) {
    try {
      const response = await axios.get(`${API_BASE_URL}/cities/${countryIsoCode}/${stateIsoCode}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener ciudades:', error);
      throw error;
    }
  }
};

export default locationService;
